module.exports = __webpack_public_path__ + "img/1F515.7060072d.svg";